import { defaultMisaOrderState } from './module-misastore-state';

export default {
	resetState(state) {
		Object.assign(state, defaultMisaOrderState);
	},
	updatelstBank(state, res) {
		state.lstBank = res;
	}
};
